export class WaterFlowPressure {
  flowRate: number; // gpm
  pressure: number; // psi
  constructor(data: { flowRate?: number; pressure?: number } = {}) {
    this.flowRate = data.flowRate;
    this.pressure = data.pressure;
  }
}
